// extracted by mini-css-extract-plugin
export default {"loginForm":"j8yfk8zpoYnpMUNCBgYG3Q==","signInBtn":"-QIl+5qmCCMvaH-GFY0oug=="};